import { useIonToast } from "@ionic/react";
import { Capacitor } from "@capacitor/core";
import { handleResponse } from "helpers/index";

function useHandleResponse() {
  const getPlatform = Capacitor.getPlatform();
  const [present] = useIonToast();

  const setResponse = (response) => {
    if (getPlatform === "web") {
      handleResponse(response);
    } else {
      let message = !response
        ? "Network Error!"
        : response?.status === 401
        ? "Unauthorized"
        : response?.status === 404
        ? "Not Found"
        : response?.status === 500
        ? "Internal Server Error"
        : response?.status === 413
        ? "Photo harus kurang dari 1mb"
        : response?.data?.message
        ? response?.data?.message
        : response?.data?.error
        ? response?.data?.error
        : response?.message
        ? response?.message
        : response?.data;
      present({
        message,
        duration: 2000,
        position: "bottom",
      });
    }
  };

  return setResponse;
}

export default useHandleResponse;
